import styled from 'styled-components';
import radio from '~/components/styled/radio';
import checkbox from '~/components/styled/checkbox';
import media from '~/utils/media';

export const Content = styled.div`
  padding: 0 7.03% 30px;
  border-right: 1px solid #f2f2f2;
  border-bottom: 1px solid #f2f2f2;
  border-left: 1px solid #f2f2f2;
  background-color: #fff;
`;

export const Card = styled.div`
  background-color: #fff;

  ${media.pcLarge`
    padding: 40px;
  `}

  ${media.tabletLarge`
    padding: 30px;
  `}

  ${media.tabletSmall`
    padding: 30px;
  `}

  ${media.mobileLarge`
    padding: 25px;
  `}

  ${media.mobileMid`
    padding: 10px;
  `}

  ${media.mobileSmall`
    padding: 10px;
  `}
`;

export const Title = styled.div`
  img{
    ${media.pcLarge`
     width: 130px;
    `}

    ${media.tabletLarge`
      width: 120px;
    `}

    ${media.tabletSmall`
      width: 120px;
    `}

    ${media.mobileLarge`
      width: 90px;
    `}

    ${media.mobileMid`
      width: 85px;
    `}

    ${media.mobileSmall`
      width: 80px;
    `}
  }
`;

export const Question = styled.h2`
  color: #222222;

  ${media.pcLarge`
    margin-top: 25px;
    font-size: 20px;
    letter-spacing: -1px;
  `}

  ${media.tabletLarge`
    margin-top: 25px;
    font-size: 17px;  
  `}

  ${media.tabletSmall`
    margin-top: 25px;
    font-size: 15px;
  `}

  ${media.mobileLarge`
    margin-top: 17px;
    font-size: 14px;
  `}

  ${media.mobileMid`
    margin-top: 14px;
    font-size: 13px;
  `}

  ${media.mobileSmall`
    margin-top: 14px;
    font-size: 11px;
    letter-spacing: normal;
  `} 
`;

export const RadioWrap = styled.div`
  display: flex;
  align-items: center;
`;

export const ColumnRadioWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ColumnLabel = styled.label `
  display: flex;
  align-items: center;
  letter-spacing: 1px;

  > p {
    font-weight: 500;
  }

  ${media.pcLarge`
    height: 35px;
    margin-top: 13px;
    font-size: 16px;`
  }
  ${media.tabletLarge`
    margin-top: 14px;
    font-size: 14px
  `}

  ${media.tabletSmall`
    margin-top: 14px;
    font-size: 13px
  `}

  ${media.mobileLarge`
    margin-top: 14px;
    font-size: 11px
  `}

  ${media.mobileMid`
    margin-top: 12px;
    font-size: 11px;

  `}

  ${media.mobileSmall`
      margin-top: 12px;
      font-size: 11px;
  `} 
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  letter-spacing: 1px;
  cursor: pointer;

  > p {
    font-weight: 500;
  }

  ${media.pcLarge`
    height: 35px;
    margin-top: 13px;
    font-size: 16px;

    & + & {
      margin-left: 16px;
  }
  `}

  ${media.tabletLarge`
    margin-top: 14px;
    font-size: 14px;
    
    & + & {
      margin-left: 10px;
    }
  `}

  ${media.tabletSmall`
    margin-top: 14px;
    font-size: 13px;

    & + & {
      margin-left: 10px;
    }
  `}

  ${media.mobileLarge`
    margin-top: 13px;
    font-size: 11px;

    & + & {
      margin-left: 10px;
    }
  `}

  ${media.mobileMid`
    margin-top: 12px;
    font-size: 11px;

    & + & {
      margin-left: 10px;
    }
  `}

  ${media.mobileSmall`
    margin-top: 12px;
    font-size: 11px;

    & + & {
      margin-left: 10px;
  `}
`;

    //Information
export const InputInformation = styled.div `
  display: flex;
  align-items: center;
  cursor: pointer;

  > p {
    width: 50px;
  }

  > input { 
    border: 1px solid #dddddd;
   }

  ${media.pcLarge`
    margin-top: 20px;
  `}

  ${media.tabletLarge`
    margin: 20px auto;
    font-size: 16px;
    letter-spacing: normal;
  `}

  ${media.tabletSmall`
    margin: 10px auto;
    font-size: 15px;
    letter-spacing: normal;
  `}

  ${media.mobileLarge`
    margin: 10px auto;
    font-size: 13px;
    letter-spacing: normal;
  `}

  ${media.mobileMid`
    margin: 10px auto;
    font-size: 12px;
    letter-spacing: normal;
  `}

  ${media.mobileSmall`
    margin: 10px auto;
    font-size: 12px;
    letter-spacing: normal;
  `} 
`;

export const InfoQuestion = styled.div`
  ${media.pcLarge`
    font-size: 16px;
    letter-spacing: normal;
  `}

  ${media.tabletLarge`
    font-size: 15px;
    letter-spacing: normal;
  `}

  ${media.tabletSmall`
    font-size: 15px;
    letter-spacing: normal;
  `}

  ${media.mobileLarge`
    font-size: 12px;
    letter-spacing: normal;
  `}

  ${media.mobileMid`
    font-size: 12px;
    letter-spacing: normal;
  `}

  ${media.mobileSmall`
    font-size: 12px;
    letter-spacing: normal;
  `} 
`;


export const Information = styled.div`
  display: flex;
  flex-direction: column;

  ${media.pcLarge`
    margin-top: 25px;

    & + & {
      margin-top: 25px;
    }
  `}

  ${media.tabletLarge`   
    & + & {
      margin-top: 22px;
    }
  `}

  ${media.tabletSmall`
    & + & {
      margin-top: 20px;
    }
  `}

  ${media.mobileLarge`
    & + & {
      margin-top: 18px;
    }
  `}

  ${media.mobileMid`
    & + & {
      margin-top: 15px;
    }
  `}

  ${media.mobileSmall`
    & + & {
      margin-top: 15px;
    }
  `} 
`;

//연령대 성별 혼인여부 라벨 
export const InfoLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;

  ${media.pcLarge`
   margin-top: 15px;

   & + & {
     margin-left: 16px;
   }
  `}

  ${media.tabletLarge`
    margin-top: 14px;
    font-size: 14px; 

    & + & {
      margin-left: 10px;
    }
  `}

  ${media.tabletSmall`
    margin-top: 12px;
    font-size: 11px; 

    & + & {
      margin-left: 10px;
    }
  `}

  ${media.mobileLarge`
    margin-top: 12px;
    font-size: 11px; 
    & + & {
      margin-left: 10px;
    }
  `}

  ${media.mobileMid`
  font-size: 11px;

   & + & {
    margin-left: 8px;
   }
  `}

  ${media.mobileSmall`
   font-size: 11px; 

   & + & {
    margin-left: 8px;
   }
  `}  
`;

//여기는 연령대 성별 혼인여부 답변 가로정렬 위해 만들어둠 
export const InfoRadio = styled.div`
  display: flex;
  align-items: center;

  ${media.mobileMid`
    margin-top: 10px;
  `}

  ${media.mobileSmall`
   margin-top: 10px;
  `} 
`;

export const Radio = styled.input.attrs({
  type: 'radio',
})`
  ${radio};
    flex: none;
    width: 16px;
    height: 16px;
    margin-right: 8px; 
`;

export const Input  = styled.input.attrs({
  type: 'text',
})`
  flex-grow: 1;
  margin-left: 8px;
  padding: 8px;
  border: solid 2px #dddddd;
  border-radius: 2px;
  background-color: none;

  &:focus {
    outline: none;
  }
`;

export const AgreeWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${media.pcLarge`
    margin-top: 15px;
  `}

  ${media.tabletLarge`
    margin-top: 12px;
  `}

  ${media.tabletSmall`
    margin-top: 12px;
  `}

  ${media.mobileLarge`
    margin-top: 12px;
  `}

  ${media.mobileMid`
    margin-top: 10px;
  `}

  ${media.mobileSmall`
    margin-top: 10px;
  `} 
`;

export const AgreeContent = styled.div`
  width: 100%;
  border: 2px solid #adadad;
  color: #444444;

  ${media.pcLarge`
      padding: 15px 20px;
      line-height: 22px;
  `}

  ${media.tabletLarge`
      padding: 10px 15px;
      font-size: 13px;
      line-height: 17px;
      word-wrap: break-word;   
  `}

  ${media.tabletSmall`
      padding: 10px 15px;
      font-size: 13px;
      line-height: 17px;
  `}

  ${media.mobileLarge`
      padding: 10px 15px;
      font-size: 12px;
      line-height: 17px;
  `}

  ${media.mobileMid`
      padding: 10px 15px;
      font-size: 11px;
      line-height: 17px;
  `}

  ${media.mobileSmall`
      padding: 10px 15px;
      font-size: 10px;
      line-height: 17px;
  `} 
`;

export const Checkbox = styled.input.attrs({
  type: 'checkbox',
})`
  ${checkbox};
  width: 20px;
  height: 20px;

 ${media.pcLarge`
    width: 18px;
    height: 18px;
  `}

  ${media.tabletLarge`
    width: 16px;
    height: 16px;
  `}

  ${media.tabletSmall`
    width: 14px;
    height: 14px;
  `}

  ${media.mobileLarge`
    width: 14px;
    height: 14px;
  `}

  ${media.mobileMid`
    width: 14px;
    height: 14px;
  `}

  ${media.mobileSmall`
    width: 12px;
    height: 12px;
  `} 
`;

export const AgreeBtn = styled.button` 
  display: flex; 
  justify-content: center;
  background-color: #326cf9;
  border-radius: 7px;
  border: none;
  box-shadow: none;
  font-weight: 600;
  color: #fff;
  cursor: pointer;

  ${media.pcLarge`
    width: 410px;
    padding: 25px;
    margin-top: 20px;
    font-size: 25px;
  `}

  ${media.tabletLarge`
    width: 500px;
    padding: 20px;
    margin-top: 15px;
    font-size: 25px
  `}

  ${media.tabletSmall`
    width: 450px;
    padding: 20px;
    margin-top: 15px;
    font-size: 25px
  `}

  ${media.mobileLarge`
    width: 310px;
    padding: 20px;
    margin-top: 15px;
    font-size: 25px
  `}

  ${media.mobileMid`
    width: 260px;
    padding: 20px;
    margin-top: 15px;
    font-size: 25px
  `}

  ${media.mobileSmall`
    width: 220px;
    padding: 18px;
    margin-top: 15px;
    font-size: 25px;
  `} 
`;

export const AgreeLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;

  ${media.pcLarge`
    margin-top: 15px;

    > p {
    margin-right: 10px;
    font-size: 19px;
    }
  `}

  ${media.tabletLarge`
    margin-top: 13px;

    > p {
    margin-right: 10px;
    font-size: 13px;
    }
  `}

  ${media.tabletSmall`
    margin-top: 15px;

    > p {
    margin-right: 8px;
    font-size: 12px;
    }
  `}

  ${media.mobileLarge`
    margin-top: 13px;

    > p {
    margin-right: 8px;
    font-size: 12px;
    }
  `}

  ${media.mobileMid`
    margin-top: 12px;

    > p {
    margin-right: 5px;
    font-size: 11px;
    }
  `}

  ${media.mobileSmall`
    margin-top: 12px;
    
    > p {
    margin-right: 5px;
    font-size: 10px;
    }
  `}
`;